export class EngagementHistoryBySubject{
    public crmUserId:number;
    public emailAddress:string;
    public propertyIds:Array<any>;
    public pageNumber:number;
    public pageSize:number;
    public sessionToken:string;
    public subject:string;
}